export const name = 'dbParserFactory';
export default function dbParserFactory() {
    //noinspection BadExpressionStatementJS
    'ngInject';

    let DB_FORMAT_CSV = "DB_FORMAT_CSV";
    let DB_FORMAT_TXT = "DB_FORMAT_TXT";


    // todo: what if there are two columns that match the same header name?

    let errors = {
      error_failedToParse:'imposer.composer-main.Composer_Failed_To_Parse_Database_File',
      error_inconsistentNumberOfColumnsAlongDb: 'imposer.composer-main.Composer_Database_File_Contains_Inconsistent_Number_Of_Columns_Between_Rows',
      error_numberOfColumnsLessThanNumberOfHeaders:'imposer.composer-main.Composer_Database_File_Contains_Insufficient_Number_Of_Columns',
      error_insufficientNumberOfRows:'imposer.composer-main.Composer_Database_File_Contains_Insufficient_Number_Of_Rows'
    };

    return {
      parseDbText: parseDbText,
      countRepetitions: countRepetitions
    };

    function parseDbText(headers1, dbText, knownFormat = null, guessingFormat = null, isPredefined = false, recordsLimitForEditing = null, repetitionColumn = null){

        let headers = headers1 || null;
        let parsedData = genericDelimiterParser(dbText, headers, knownFormat, guessingFormat, recordsLimitForEditing, null, repetitionColumn);

        let data = parsedData.data;

        // check if parse failed
        if(data === null || data.length === 0){
            return {error:errors.error_failedToParse};
        }
        else{
            // if parse success
            // Check if the given DB is legal - number of columns in all rows is the same
            /*if(isContainSameNumberOfColumnsAtAllRows(data) === false)
            {
                return {error:errors.error_inconsistentNumberOfColumnsAlongDb};
            }*/
           // else
           // {
                let discoveredHeadersInDb = null;

                if(headers === null){
                    let separatedDataHeaders = separateHeadersAndData(data);
                    if(separatedDataHeaders === null){
                        return {error:errors.error_insufficientNumberOfRows};
                    }
                    else{
                        discoveredHeadersInDb = separatedDataHeaders.headers;
                        data = separatedDataHeaders.data;
                        parsedData.repetitions.repetitionColIndex = getRepetitionColIndex(discoveredHeadersInDb, repetitionColumn);

                        if(isPredefined) {
                          return {
                            data: data,
                            headers: discoveredHeadersInDb,
                            skipFirstRow: true,
                            numOfRecords: parsedData.numOfRecords,
                            repetitions: parsedData.repetitions,
                            delimiter: parsedData.delimiter
                          };
                        }else{
                          return {
                            data: data,
                            headers: discoveredHeadersInDb,
                            skipFirstRow: false,
                            numOfRecords: parsedData.numOfRecords,
                            repetitions: parsedData.repetitions,
                            delimiter: parsedData.delimiter
                          };
                        }
                    }
                }
                else{
                    // check if first row contains at least the same number of columns as number of headers
                    // note - we already checked that all rows has the same number of columns between themselves.
                    if(validateNumberOfColumnsAtLeastAsNumberOfHeaders(headers, data) === false){
                        return {error:errors.error_numberOfColumnsLessThanNumberOfHeaders};
                    }
                    else{
                        // identify if first data row include all headers
                        if(isFirstRecordIncludesAllHeaders(headers, data)){
                            // remove all column that do not match known header
                            data = removeColumnsThatDoNotHaveKnownHeader(headers, data);
                            data = sortColumnsAccordingToHeader(headers, data);

                            // remove the first line - as that is headers.
                            data.shift();
                            addDataRowIfAllWeHaveIsHeadersOnly(data, headers);
                            // return data and headers, while indicating skip of first.
                            return {
                                data:data,
                                headers: headers,
                                skipFirstRow: true,
                                numOfRecords: parsedData.numOfRecords,
                                repetitions: parsedData.repetitions,
                                delimiter: parsedData.delimiter
                            };
                        }
                        else{
                            // if not then it means that the data does not include header as first row
                            // remove all column beyond number of headers
                            data = removeColumnsBeyondNumberOfHeaders(headers, data);

                            // return data with no skip indication
                            return {
                                data:data,
                                headers: headers,
                                skipFirstRow: false,
                                numOfRecords: parsedData.numOfRecords,
                                repetitions: parsedData.repetitions,
                                delimiter: parsedData.delimiter
                            };
                        }
                    }
                }
            //}
        }
    }

    function addDataRowIfAllWeHaveIsHeadersOnly(data, headers){
        if(data.length === 0){
            data.push(headers);
        }
    }

    // Note - this method assume we already tested that validateNumberOfColumnsAtLeastAsNumberOfHeaders return true
    function sortColumnsAccordingToHeader(headers, data){

        // for each header - according to headers order
        headers.forEach(function(header, iColumnWhereItShouldBe){
            // look for the matching header column
            let foundColumnAt = -1;
            for(let iColumn=0; iColumn < data[0].length; iColumn++){
                if(header === data[0][iColumn]){
                    foundColumnAt = iColumn;
                    break;
                }
            }

            if(foundColumnAt === -1){
                return null;
            }else{
                // swap the columns where it was located with the column where it should be, if not in place
                if(iColumnWhereItShouldBe !== foundColumnAt){
                    for(let iRecord = 0; iRecord < data.length; iRecord++){
                        let temp = data[iRecord][iColumnWhereItShouldBe];
                        data[iRecord][iColumnWhereItShouldBe] = data[iRecord][foundColumnAt];
                        data[iRecord][foundColumnAt] = temp;
                    }
                }
            }
        });

        return data;
    }

    // Note - this method assume we already tested that validateNumberOfColumnsAtLeastAsNumberOfHeaders return true
    function removeColumnsBeyondNumberOfHeaders(headers, data){
        if(data[0].length > headers.length){
            let removeFromIndex = headers.length;
            let removeToIndex = data[0].length - 1;

            for (let iRecord = 0; iRecord < data.length; iRecord++) {
                for (let iColumn = removeFromIndex; iColumn <= removeToIndex; iColumn++) {
                    data[iRecord].splice(removeFromIndex, 1);
                }
            }
        }

        return data;
    }

    // Note - this method assume we already tested that validateNumberOfColumnsAtLeastAsNumberOfHeaders return true
    function removeColumnsThatDoNotHaveKnownHeader(headers, data){

        if(headers.length < data[0].length) {
            let columnsNotMatchHeader = [];

            // locate all columns that do not match to header
            for (let iColumn = 0; iColumn < data[0].length; iColumn++) {
                let foundIt = false;
                for (let iHeader = 0; iHeader < headers.length; iHeader++) {
                    if (headers[iHeader] === data[0][iColumn]) {
                        foundIt = true;
                        break;
                    }
                }
                if(foundIt === false){
                    columnsNotMatchHeader.push(iColumn);
                }
            }

            // now, run on data and remove all columns that were not identified according to header
            for (let iRecord = 0; iRecord < data.length; iRecord++) {
                for (let iColumn = 0; iColumn < columnsNotMatchHeader.length; iColumn++) {
                    data[iRecord].splice(columnsNotMatchHeader[iColumn], 1);
                }
            }
        }

        return data;
    }

    function isFirstRecordIncludesAllHeaders(headers, data){
        for(let iHeader = 0; iHeader < headers.length; iHeader++){
            let headerFound = false;
            for(let iColumn = 0; iColumn < data[0].length; iColumn++){
                if(headers[iHeader] === data[0][iColumn]){
                    headerFound = true;
                    break;
                }
            }
            if(headerFound === false){
                return false;
            }
        }

        return true;
    }

    // NOTE: the following assume that the entire data has same columns for all of its records.
    function validateNumberOfColumnsAtLeastAsNumberOfHeaders(headers, data){
        if(data[0].length >= headers.length){
            return true;
        }else{
            return false;
        }
    }

    function separateHeadersAndData(data){
        if(data.length < 2){
            return null;
        }else{
            let theHeaders = data[0];
            //let dataAfterCopyByValue = data.splice(0);
            let dataAfterCopyByValue = data.slice(1, data.length + 1);

            return {
                headers:theHeaders,
                data: dataAfterCopyByValue
            };
        }
    }


    function isContainSameNumberOfColumnsAtAllRows(data){
        let numberOfColumns = null;
        for(let iRecord = 0; iRecord < data.length; iRecord++){
            if(numberOfColumns === null){
                numberOfColumns = data[iRecord].length;
            }else{
                if(numberOfColumns !== data[iRecord].length){
                    return false;
                }
            }
        }

        return true;
    }


    // assumption -
    // there is either knownFormat or Guessing format - can not be that both are null!!!!
    // known format is TXT only
    // guessing can be CSV or TXT
    function genericDelimiterParser(inputText, headers, knownFormat = null, guessingFormat = null, recordsLimitForEditing = null, fileSizeLimitForEditing = null, repetitionColumn = null){
        let parsedData = null;
        let delimiter = null;
        let firstRecordOnly = true;

        if(headers === undefined){
            headers = null;
        }

        let repetitionColIndex = getRepetitionColIndex(headers, repetitionColumn);

        // regardless to file extension - first try to identify the header by any of the common delimiters - if identified - use that.

        // case of known format and txt
        if(knownFormat !== null && knownFormat === 'TXT'){
          delimiter = "\t";
          parsedData = genericDelimiterParserWithDelimiter(inputText, delimiter, headers, false, recordsLimitForEditing, fileSizeLimitForEditing, repetitionColIndex, repetitionColumn);
        }else{

          // try finding the format upon header - regardless of extention type.
          if(headers !== null) {
            // calculate number of bytes for header so parser would not by mistake run on the entire DB trying to find the header.
            let maxHeaderNumberOfBytes = 0;
            for (let iColumn in headers) {
              if (headers[iColumn] !== undefined && headers[iColumn] !== null) {
                maxHeaderNumberOfBytes += headers[iColumn].length;
              }
            }

            maxHeaderNumberOfBytes += 2 * headers.length + headers.length; // add potential " at start and end of each column + delimiter

            let delimiters = [",", ";", "\t", " "];

            for (let iDelimiter in delimiters) {
              let genericDelimiterResult = genericDelimiterParserWithDelimiter(inputText, delimiters[iDelimiter], headers, firstRecordOnly, null, maxHeaderNumberOfBytes);

              if (genericDelimiterResult !== undefined && genericDelimiterResult !== null && genericDelimiterResult.data !== undefined && genericDelimiterResult.data !== null && genericDelimiterResult.data[0]) {
                if (checkIfMatch(genericDelimiterResult.data[0], headers)) {
                  parsedData = genericDelimiterParserWithDelimiter(inputText, delimiters[iDelimiter], headers, false, recordsLimitForEditing, fileSizeLimitForEditing, repetitionColIndex, repetitionColumn);
                  delimiter = delimiters[iDelimiter];
                  break;
                }
              }
            }
          }

          // if we didnt find the delimiter upon header, or header is not given and it is not known format, then try the following upon file extension and other guesses.
          if(guessingFormat !== null && parsedData === null){
            if(guessingFormat === 'TXT'){
              parsedData = genericDelimiterParserWithDelimiter(inputText,"\t", headers, false, recordsLimitForEditing, fileSizeLimitForEditing, repetitionColIndex, repetitionColumn);
              delimiter = "\t";
            }else if(guessingFormat === 'CSV'){
              // here we can have two options either ',' or ';' need to figure which one.

              // if there is header, then try to find out according to header
              if(headers !== null){
                // parse first record only according to ','
                let commaSepFirstRowData = genericDelimiterParserWithDelimiter(inputText,",", headers, firstRecordOnly).data;

                if(checkIfMatch(commaSepFirstRowData[0],headers)){
                  // if header match first row then we know it is indeed ,
                  parsedData = genericDelimiterParserWithDelimiter(inputText,",", headers, false, recordsLimitForEditing, fileSizeLimitForEditing, repetitionColIndex, repetitionColumn);
                  delimiter = ",";
                }else{

                  let semiColonSepFirstRowData = genericDelimiterParserWithDelimiter(inputText,";", headers, firstRecordOnly).data;
                  if(checkIfMatch(semiColonSepFirstRowData[0],headers)){
                    // if header match first row then we know it is indeed ;
                    parsedData = genericDelimiterParserWithDelimiter(inputText,";", headers, false, recordsLimitForEditing, fileSizeLimitForEditing, repetitionColIndex, repetitionColumn);
                    delimiter = ";";
                  }else{
                    // if we are here - then it means that it is CSV but that CSV does not include header as first row.
                    // in that case, we will take the one most fit to headers according to maxColumnNumber
                    // we know it is CSV but we can not tell if it is ; or , according to header - in that case we will take the one with more columns
                    let fullDataComma = genericDelimiterParserWithDelimiter(inputText,",", headers, false, recordsLimitForEditing, fileSizeLimitForEditing, repetitionColIndex, repetitionColumn);
                    let fullDataSemiColon = genericDelimiterParserWithDelimiter(inputText,";", headers, false, recordsLimitForEditing, fileSizeLimitForEditing, repetitionColIndex, repetitionColumn);

                    if(fullDataComma.maxColumnNumber  > fullDataSemiColon.maxColumnNumber){
                      // then it is ,
                      parsedData = fullDataComma;
                      delimiter = ",";
                    }else {
                      // then it should be ;
                      parsedData = fullDataSemiColon;
                      delimiter = ";";
                    }
                  }
                }
              }else{
                // if we are here then we know it is CSV, but we dont have headers to match it to.
                // in that case, we will choose the one with more columns.
                let fullDataComma = genericDelimiterParserWithDelimiter(inputText,",", headers, false, recordsLimitForEditing, fileSizeLimitForEditing);
                let fullDataSemiColon = genericDelimiterParserWithDelimiter(inputText,";", headers, false, recordsLimitForEditing, fileSizeLimitForEditing);
                if(fullDataComma.maxColumnNumber > fullDataSemiColon.maxColumnNumber){
                  // then it is ,
                  parsedData = fullDataComma;
                  delimiter = ",";
                }else{
                  // then it should be ;
                  parsedData = fullDataSemiColon;
                  delimiter = ";";
                }
              }
            }
          }
        }

        if(parsedData === null){
            // then we have no idea what it is.
            // we will just do /t
            parsedData = genericDelimiterParserWithDelimiter(inputText,"\t", headers, false, recordsLimitForEditing, fileSizeLimitForEditing, repetitionColIndex, repetitionColumn);
            delimiter = "\t";
        }

        return {
          data: parsedData.data,
          numOfRecords: parsedData.records,
          repetitions: parsedData.repetitions,
          isRepetitionValuesLegal: parsedData.isRepetitionValuesLegal,
          delimiter: recordsLimitForEditing !== null ? delimiter.charCodeAt(0) : null
        };
    }

    function checkIfMatch(data, header){
        if(header.length > data.length){
            return false;
        }else{
            for(let iCol = 0; iCol < header.length; iCol++){
                if(header[iCol] !== data[iCol]){
                    return false;
                }
            }

            return true;
        }
    }

    function jumpOverEndOfLine(charPointer, inputText){
      if(charPointer<inputText.length){
        if(inputText[charPointer] === '\n'){
          charPointer++;
        }else if(inputText[charPointer] === '\r'){
          charPointer++; // jump over \r
          if(charPointer<inputText.length && inputText[charPointer] === '\n'){
            charPointer++; // jump over \n
          }
        }
      }

      return charPointer;
    }

    function genericDelimiterParserWithDelimiter(inputText, delimiter, headers, firstRecordOnly = false, recordsLimitForEditing = null, maxNumOfBytesToCheck = null, repetitionColIndex = null, repetitionColumn = null){

        let charPointer = 0;
        let data = [];

        let endOfFile = false;
        let recordsCounter = 0;
        let repetitionCounter = 0;
        let maxColumnNumber = 0;
        let isRepetitionValuesLegal = true;
        let tempRepetitionColIndex = repetitionColIndex;

        for(let iRecord = 0; inputText && charPointer < inputText.length; iRecord++){

            if(endOfFile){
                break;
            }

            recordsCounter++;

            if(!isRecordLimitReached(iRecord, recordsLimitForEditing)) {
              data.push([]); // create new record
            }

            let endOfRecordIdentified = false;
            for(let iColumn = 0; charPointer < inputText.length; iColumn++){
                let value = "";

                // check if first character in value is "
                let firstIsDoubleQuotes = inputText[charPointer] === '"' ? true : false;

                // if the first char is ", then value should start one char after it
                if(firstIsDoubleQuotes){
                    charPointer++;
                }

                // run over all characters until end of value -
                let endOfValue = false;
                while(!endOfValue){
                  if(maxNumOfBytesToCheck !== null && maxNumOfBytesToCheck <=  charPointer){
                    return null;
                  }

                  // identify if it is end of value and progress charPointer to first value of either next column or next record
                  if(firstIsDoubleQuotes){
                      if((inputText[charPointer] === '"') && ((charPointer+1 === inputText.length) || (inputText[charPointer+1] === delimiter)||(inputText[charPointer+1] === "\n") || (inputText[charPointer+1] === "\r"))){
                          endOfValue = true;
                          if(charPointer+1 === inputText.length){ // we finished this value and got to end of record and end of file
                              if(!isRecordLimitReached(iRecord, recordsLimitForEditing)) {
                                data[iRecord].push(value);
                              }
                              endOfRecordIdentified = true;
                              endOfFile = true;
                          }else if((inputText[charPointer+1] === "\n") || (inputText[charPointer+1] === "\r")){ // we finished this value and got to end of record
                              if(!isRecordLimitReached(iRecord, recordsLimitForEditing)) {
                                data[iRecord].push(value);
                              }
                              endOfRecordIdentified = true;
                              charPointer+=1;  //jump over "

                              // jump over \n \r or both - if not end of data
                              charPointer = jumpOverEndOfLine(charPointer, inputText);

                          }else if(inputText[charPointer+1] === delimiter){ // we only finished value
                              if(!isRecordLimitReached(iRecord, recordsLimitForEditing)) {
                                data[iRecord].push(value);
                              }
                              charPointer += 2; // need to jump over " + delimiter
                          }
                      }
                    }else{
                        if((charPointer === inputText.length) || (inputText[charPointer] === delimiter)||(inputText[charPointer] === "\n") || (inputText[charPointer] === "\r")){
                            endOfValue = true;
                            if(charPointer === inputText.length){ // we finished this value and got to end of record and end of file
                                if(!isRecordLimitReached(iRecord, recordsLimitForEditing)) {
                                  data[iRecord].push(value);
                                }
                                endOfRecordIdentified = true;
                                endOfFile = true;
                            }else if((inputText[charPointer] === "\n") || (inputText[charPointer] === "\r")){ // we finished this value and got to end of record
                                if(!isRecordLimitReached(iRecord, recordsLimitForEditing)) {
                                  data[iRecord].push(value);
                                }
                                endOfRecordIdentified = true;

                                // jump over \n \r or both - if not end of data
                                charPointer = jumpOverEndOfLine(charPointer, inputText);

                            }else if(inputText[charPointer] === delimiter){ // we only finished value
                                if(!isRecordLimitReached(iRecord, recordsLimitForEditing)) {
                                  data[iRecord].push(value);
                                }
                                charPointer += 1; // need to jump over " + delimiter
                            }
                        }
                    }

                    if(charPointer >= inputText.length){
                        endOfRecordIdentified = true;
                        endOfFile = true;
                        endOfValue = true;
                    }

                    if(!endOfValue){
                        value += inputText[charPointer];
                        charPointer++;

                        // in case it is "" two double quotes - the one is taken to value and then should skip the next "
                        if((firstIsDoubleQuotes) && (inputText[charPointer-1] === '"') && (inputText[charPointer] === '"')){
                            charPointer++;
                        }
                    }
                }

                if(iRecord === 0 && repetitionColumn === value){
                  tempRepetitionColIndex = iColumn;
                }

                if(tempRepetitionColIndex === iColumn && repetitionColumn && repetitionColumn !== value){
                  let recordRepetitionValue = countRepetitionsAndCheckIfLegal(value);
                  if (recordRepetitionValue.valid === false) {
                    isRepetitionValuesLegal = false;
                  } else {
                    repetitionCounter += recordRepetitionValue.count;
                  }
                }

                if(endOfRecordIdentified){
                    break;
                }
            }

            if(!isRecordLimitReached(iRecord, recordsLimitForEditing) && data[iRecord].length > maxColumnNumber){
                maxColumnNumber = data[iRecord].length;
            }

            if(firstRecordOnly){
                return {data:data, maxColumnNumber:maxColumnNumber};
            }
        }

        let numberOfColumns = maxColumnNumber;
        if((headers !== undefined) && (headers !== null)){
            numberOfColumns = headers.length;
        }

        for(let iRecord = 0; iRecord < data.length; iRecord++){
            if(data[iRecord].length < numberOfColumns){
                for(let iColumn = data[iRecord].length - 1; iColumn < numberOfColumns; iColumn++){
                    data[iRecord][iColumn] = "";
                }
            }
        }

        //Removing header from recordCounter if first record equal to headers
        if(!headers || headers && isFirstRecordIncludesAllHeaders(headers, data)){
          recordsCounter--;
        }

        return {
          data:data,
          maxColumnNumber: maxColumnNumber,
          records : recordsCounter,
          repetitions : {
            repetitionCounter: repetitionCounter,
            repetitionColIndex: repetitionColIndex,
            isRepetitionValuesLegal: isRepetitionValuesLegal
          },
        };
        
        function isRecordLimitReached(iRecord, recordLimit){
          return recordLimit !== null && iRecord - 1 >= recordLimit;
        }
    }

    function countRepetitionsAndCheckIfLegal(value){
      if(isNaN(value) || !Number.isInteger(+value) || +value < 0 || value.length > 15){
        return {
          valid: false,
          count: 0
        };
      }else{
        return {
          valid: true,
          count: +value
        };
      }
    }

    function countRepetitions(repetitionColIndex, data, recount = false){
      let isValid = true;
      let repetitionsCounter = 0;
      data.forEach(record => {
        for(let iColumn = 0 ; iColumn < record.length ; iColumn++){
          if(repetitionColIndex === iColumn){
            let recordRepetition = countRepetitionsAndCheckIfLegal(record[iColumn]);
            if(recordRepetition.valid === false){
              isValid = false;
              break;
            }else if(recount){
              repetitionsCounter += recordRepetition.count;
            }
          }
        }
      });
      return {
        valid: isValid,
        count: repetitionsCounter
      };
    }

    function getRepetitionColIndex(headers, repetitionColumn){
      if(headers !== null) {
        if (repetitionColumn !== null) {
          for (let i = 0; i < headers.length; i++) {
            if (repetitionColumn === headers[i]) {
              return  i;
            }
          }
        }
      }
      return null;
    }
}
